import React from 'react';
import './Icon.scss';

interface Props {
    icon: React.ReactNode;
    theme?:
        | 'dark'
        | 'soft'
        | 'white'
        | 'action'
        | 'none'
        | 'danger'
        | 'warning'
        | 'text'
        | 'lighter'
        | 'pink'
        | 'green-soft'
        | 'green-3'
        | 'highlighted';
    size?: 'tiny' | 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl';
    align?: 'left' | 'right' | 'center';
    onClick?: (params?: any) => void;
    variant?: 'contained' | 'outlined';
}

const Icon: React.FC<Props> = ({
    icon,
    theme = 'dark',
    size = 'xs',
    align = 'left',
    onClick,
    variant = 'contained',
}) => {
    return (
        <div
            className={`Icon variant-${variant} theme-${theme} size-${size} align-${align} ${
                Boolean(onClick) ? 'cursor-pointer' : ''
            }`}
            onClick={(e) => onClick && onClick(e)}
        >
            {icon}
        </div>
    );
};

export default Icon;
